import {
  dashboardActionTypes,
  userActionTypes,
} from './types';
import { dashboardService } from '../services';

const getOverview = (query) => {
  const requestKey = JSON.stringify(query || {});

  return (dispatch, getState) => {
    dispatch(request(requestKey));

    dashboardService.getOverview(query).then(
      overview => dispatch(success(overview, requestKey)),
      error => dispatch(failure(
        error,
        requestKey,
        getState().authentication.pendingRefreshingToken,
      )),
    );
  };
};

const request = requestKey => ({
  type: dashboardActionTypes.OVERVIEW_REQUEST,
  requestKey,
});

const success = (overview, requestKey) => ({
  type: dashboardActionTypes.OVERVIEW_SUCCESS,
  overview,
  requestKey,
});

const failure = (error, requestKey, pendingRefreshToken) => {
  if (error.code === 'invalidToken') {
    if (pendingRefreshToken) {
      return {
        type: userActionTypes.PENDING_REFRESH_TOKEN,
        error: error.error,
      };
    }
    return {
      type: userActionTypes.INVALID_TOKEN,
      error: error.error,
    };
  }

  return {
    type: dashboardActionTypes.OVERVIEW_FAILURE,
    error: error.error || error.message,
    requestKey,
  };
};

export const dashboardActions = {
  getOverview,
};
